import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import useModal from '@src/utils/hooks/use-modal';
import VerifyModal from '@src/business-components/verify-modal';
import VerifyModalStore from '@src/business-components/verify-modal/store';
import request from '@src/utils/request';
import { useEffect } from 'react';
import $$tracker from '@src/tracker';
class JobRecordStore extends BaseStore {
  // @observable list = [{ jobName: '1231' }, { jobName: '1231' }, { jobName: '1231' }];
  @observable list = [];

  @observable next = '';

  @observable pageConfig = {};

  // list = [];

  @observable isVerify = false;

  @observable isLoading = true;

  //分页用的每页条数
  @observable limit = 10;

  @observable currentPage = -1;

  @observable allList = [];

  @observable pageTurningLock = false;

  @observable allJobList = [];

  @observable isFirst = true;

  /**
   * 社招职位数据
   */
  @observable socialJobList = [];
  /**
   * 校招职位数据
   */
  @observable campusJobList = [];

  /**
   * 招聘模式 social：社招 campus：校招
   */
  @observable mode = 'social';

  @observable total = 0;

  /**
   * 组织ID
   */
  // @observable orgId = 'xishanju-test';

  /**
   * 保存每一页的 next 值
   */
  @observable nextList = [];

  verifyModalStore = new VerifyModalStore({
    successCallback: () => {
      this.isLoading = true;
      this.getUserRecord();
    }
  });

  clickVerify() {
    $$tracker.clickJxyz();
    if (!!window.userAccount) {
      this.modals.verifyModal.open();
    } else {
      window.XPASS.signin();
    }
  }
  clickPrev() {
    if (this.pageTurningLock) return; // 如果分页锁定，则直接返回
    this.pageTurningLock = true; // 设置分页锁定

    if (this.currentPage <= 0) {
      // 如果是第一页，则不做任何操作（或可以根据需要显示提示信息）
      // console.log('已经是第一页');
      this.pageTurningLock = false; // 解锁分页
      return;
    }

    this.currentPage = this.currentPage - 1; // 当前页码减1
    this.next = this.nextList[this.currentPage]; // 恢复上一页的 next 值
    this.updateList(); // 更新当前页数据
  }

  clickNext() {
    if (this.pageTurningLock || !this.hasNext) return; // 如果分页锁定或没有下一页，则直接返回

    this.pageTurningLock = true; // 设置分页锁定
    this.getUserRecord('next'); // 获取下一页数据
  }

  @computed
  get hasNext() {
    // 判断是否有下一页，这里简单判断next是否为true或存在更多数据的逻辑
    // 根据实际情况，可能需要更复杂的逻辑
    // return !!this.next;
    return this.next !== false && this.next !== undefined && (this.allList.length > this.currentPage + 1 || this.next);
  }

  /**
   * 简历状态
   * @param item
   * @returns {*|string}
   */
  getStageStatus = item => {
    if (item.basicInfo.archived /* 为 true 时根据 archiveType 显示最终状态*/) {
      /**
       * 1:被候选人拒绝
       * 2：被我们拒绝（淘汰）
       * 3：录用
       * 4：系统原因
       * 5：离职
       */
      switch (item.basicInfo.archiveReasons.type) {
        case 1:
          return '暂不匹配';
        case 2:
          return '暂不匹配';
        case 3:
          return '已录用';
        case 4:
          return '暂不匹配';
        case 5:
          return '已离职';
        default:
          return '未知状态';
      }
    } else {
      return item.basicInfo.stage.name;
    }
  };

  getUserRecord(status = 'next') {
    return request
      .post('api/ssg_recruiting_cn/v1/api-platform/v2/data/ehrApplications', {
        limit: this.limit,
        next: this.next ? this.next : undefined
      })
      .then(res => {
        this.isLoading = false;

        if (status === 'next') {
          this.currentPage = this.currentPage + 1; // 更新当前页码
          this.allList[this.currentPage] = res.data || []; // 更新当前页数据到allList中
          this.list = this.allList[this.currentPage]; // 更新当前显示的数据
          this.nextList[this.currentPage] = res.next; // 保存当前页的 next 值
          this.next = res.next; // 更新下一页标志
          console.log(!!this.next, '-------------------------------');
          this.isFirst = false;
        }
        this.isVerify = true; // 设置数据已验证
        this.pageTurningLock = false; // 解锁分页
      })
      .catch(error => {
        console.error('请求失败', error.msg);
        if (error.code === 10012) {
          this.isVerify = false;
        }
        this.isLoading = false;
        this.pageTurningLock = false; // 解锁分页
      });
  }
  updateList() {
    // 更新当前页数据的通用方法，可以根据需要从allList中获取或执行其他逻辑
    this.list = this.allList[this.currentPage] || [];
    this.pageTurningLock = false;
  }
  getConfig() {
    return request
      .get('api/ssg_recruiting_cn/v1/biz/get_config', {})
      .then(res => {
        // console.log(res);
        this.captcha_id = res.data.captcha_id;
        window.captcha_id = this.captcha_id;
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }

  // getUserInfo() {
  //   return request
  //     .post('api/ssg_recruiting_cn/v1/biz/get_current_user', {})
  //     .then(res => {
  //       // console.log(res);
  //       this.account = res.data.account;
  //     })
  //     .catch(error => {
  //       console.error('GET 请求失败', error);
  //     });
  // }

  logout() {
    return request
      .post('api/ssg_recruiting_cn/v1/biz/logout', {})
      .then(res => {
        // console.log(res);
        // this.account = res.data.account;
        window.XPASS.exit();
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }

  async getSocialJobList() {
    // const queryParams = {
    //   mode: 'social',
    //   offset: 0,
    //   limit: 100
    // };
    // return request
    //   .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
    //     ...queryParams
    //   })
    //   .then(res => {
    //     this.total = res.total;
    //     this.socialJobList = res.jobs;
    //   })
    //   .catch(error => {
    //     console.error('GET 请求失败', error);
    //   });
    const queryParams = {
      mode: 'social',
      offset: 0,
      limit: 100
    };
    let allJobs = [];

    try {
      // 先发起第一次请求，获取总条数 total 和第一批数据
      const firstResponse = await request.get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
        ...queryParams
      });
      this.total = firstResponse.total;
      allJobs = allJobs.concat(firstResponse.jobs);

      // 计算还需要请求的总条数
      let remainingCount = this.total - allJobs.length;

      // 若还有剩余数据需要请求，则继续循环请求
      while (remainingCount > 0) {
        // 更新偏移量，准备下一次请求
        queryParams.offset += queryParams.limit;
        const response = await request.get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
          ...queryParams
        });
        allJobs = allJobs.concat(response.jobs);
        // 更新剩余未请求的数据条数
        remainingCount = this.total - allJobs.length;
      }

      // 把所有获取到的工作列表数据赋值给 this.socialJobList
      this.socialJobList = allJobs;
    } catch (error) {
      // 捕获请求过程中可能出现的错误并打印错误信息
      console.error('GET 请求失败', error);
    }
  }
  // getCampusJobList() {
  //   const queryParams = {
  //     mode: 'campus',
  //     offset: 0,
  //     limit: 99999
  //   };
  //   return request
  //     .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
  //       ...queryParams
  //     })
  //     .then(res => {
  //       this.campusJobList = res.jobs;
  //     })
  //     .catch(error => {
  //       console.error('GET 请求失败', error);
  //     });
  // }

  async getCampusJobList() {
    const queryParams = {
      mode: 'campus',
      offset: 0,
      limit: 100 // 通常建议不要设为 99999，合理设置分页大小
    };
    let allJobs = [];

    try {
      // 先发起第一次请求，获取总条数 total 和第一批数据
      const firstResponse = await request.get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
        ...queryParams
      });
      const total = firstResponse.total;
      allJobs = allJobs.concat(firstResponse.jobs);

      // 计算还需要请求的总条数
      let remainingCount = total - allJobs.length;

      // 若还有剩余数据需要请求，则继续循环请求
      while (remainingCount > 0) {
        // 更新偏移量，准备下一次请求
        queryParams.offset += queryParams.limit;
        const response = await request.get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
          ...queryParams
        });
        allJobs = allJobs.concat(response.jobs);
        // 更新剩余未请求的数据条数
        remainingCount = total - allJobs.length;
      }

      // 把所有获取到的工作列表数据赋值给 this.campusJobList
      this.campusJobList = allJobs;
    } catch (error) {
      // 捕获请求过程中可能出现的错误并打印错误信息
      console.error('GET 请求失败', error);
    }
  }
  goList() {
    const url = this.mode === 'social' ? 'jobList.html' : 'campusList.html';
    this.jumpPage(url);
  }

  use() {
    super.use();
    this.modals = {
      verifyModal: useModal(VerifyModal, { store: this.verifyModalStore })
    };
    useMount(async () => {
      // this.getUserInfo();
      $$tracker.loadPageYpjl();

      window.__FUN_LINK_PAGE_DATA_PROMISE__.then(res => {
        const { data, status } = res;
        // console.log('data', data.pageConfig);
        // console.log(data);
        this.pageConfig = data.pageConfig;
        this.mode = data.modeConfig.mode;
        this.getUserRecord('next');

        this.getCampusJobList();
        this.getSocialJobList();
      });
      // this.getConfig();
      // this.modals.verifyModal.open();
      // window.XPASS.signin();
    });

    useEffect(
      () => {
        if (this.socialJobList.length > 0 && this.campusJobList.length > 0 && this.list.length > 0) {
          // this.allJobList = this.socialJobList.concat(this.campusJobList);
          let allJobList = this.socialJobList.concat(this.campusJobList);

          // 创建一个以 job id 为键，job 为值的映射对象，方便快速查找
          const jobMap = new Map();
          allJobList.forEach(job => {
            jobMap.set(job.id, job);
          });

          this.list.forEach(item => {
            const jobId = item.jobInfo.id;

            const findJob = jobMap.get(jobId);
            if (findJob) {
              // 处理多个 locations，优先显示 city，没有则显示 province，将信息拼接成字符串
              const locationStrings = findJob.locations
                .map(location => location.city || location.province)
                .filter(location => location)
                .join(' ');
              item.jobLocation = locationStrings;
            }
          });

          // console.log(allJobList);
          // this.list.forEach(item => {
          //   console.log(item.jobInfo.id);
          //   const findJob = allJobList.find(job => job.id === item.jobInfo.id);
          //   // console.log(findJob.locations[0]?.province);

          //   // console.log(findJob);

          //   allJobList.forEach((job, index) => {
          //     // console.log(job.id, index);

          //     if (job.id === item.jobInfo.id) {
          //       item.jobLocation = job.locations[0]?.city;
          //     }
          //   });
          //   if (findJob) {
          //     item.jobLocation = findJob.locations[0]?.city;
          //   }
          // });
        }
      },
      [this.socialJobList, this.campusJobList, this.list]
    );
  }
}

export default JobRecordStore;
